import React from 'react';
import { saveAs } from 'file-saver';
import { isNullish } from '~/helpers';
import { BsHeart, BsFillHeartFill } from "react-icons/bs";
import CryptoJS from 'crypto-js';

export const STATUS_COURSE_BLOCKED = 0
export const STATUS_COURSE_UNLOCKED = 1
export const STATUS_COURSE_VIEWED = 2
export const STATUS_COURSE_COMPLETED = 3
export const STATUS_COURSE_REPROVED = -1
export const STATUS_COURSE_PENDING_CONNECTION = 4
export const STATUS_COURSE_IN_PROGRESS = 5

export const STATUS_MODULE_BLOCKED = 0
export const STATUS_MODULE_UNLOCKED = 1
export const STATUS_MODULE_VIEWED = 2
export const STATUS_MODULE_COMPLETED = 3
export const STATUS_MODULE_REPROVED = -1
export const STATUS_MODULE_PENDING_CONNECTION = 4
export const STATUS_MODULE_IN_PROGRESS = 5

export const auth_config = {
  identityPoolId: "",
  region: "",
  identityPoolRegion: "",
  userPoolId: "",
  userPoolWebClientId: "",
  authenticationFlowType: "",
}

export const getCourseCategoryId = (id, courses) => {
  //let category_id_temp = "";
  let category_id = "";

  //let course_id_temp = "";
  //let course_id = "";

  for (let i = 0; i < courses.length; i++) {
    //category_id_temp = courses[i]._id;
    for (let e = 0; e < courses[i].repository.length; e++) {
      if(id === courses[i].repository[e]._id){
        category_id = courses[i]._id;
      }
    }
    
    
  }
  return category_id;

}

export const getModulesStatusFromCourse = (course, module_id) => {

  let modules_arr = [];
  let next_module_id = null;

  course.moduls.map((module, index) => {

    if(module._id === module_id){
      if(course.progressive_mode){
        if(course.moduls[index+1]){
          next_module_id = course.moduls[index+1]._id;
        }
      }
      //console.log("a")
      modules_arr.push( { _id: module._id, status: module.evaluations.length ? STATUS_MODULE_VIEWED : STATUS_MODULE_COMPLETED } );
      //modules_arr.push( { _id: module._id, status: course.evaluations.length ? STATUS_COURSE_COMPLETED : STATUS_COURSE_COMPLETED } );//STATUS_COURSE_VIEWED
    }else{
      //console.log("b")
      modules_arr.push( { _id: module._id, status: module.status } );
    }

  })

  let course_status = STATUS_COURSE_COMPLETED;

  modules_arr.forEach(module => {
    if(module.status !== STATUS_COURSE_VIEWED && module.status !== STATUS_COURSE_COMPLETED){
      course_status = STATUS_COURSE_IN_PROGRESS;
    }
    if(next_module_id){
      if(next_module_id === module._id){
        module.status = STATUS_COURSE_UNLOCKED;
      }
    }
  });

  const all_modules_status = modules_arr.filter(mod => (mod.status !== STATUS_COURSE_COMPLETED));// && mod.status !== STATUS_COURSE_VIEWED
  if(all_modules_status.length){
    course_status = STATUS_COURSE_IN_PROGRESS;
  }else{
    if(course.evaluations.length){
      course_status = STATUS_COURSE_VIEWED;
    }else{
      course_status = STATUS_COURSE_COMPLETED;
    }
  }

  /*
  if(course.evaluations.length){
    if("assessment_approved" in course.evaluations[0]){
      if(!course.evaluations[0].assessment_approved){
        course_status = STATUS_COURSE_IN_PROGRESS;
      }
    }else{
      course_status = STATUS_COURSE_IN_PROGRESS;
    }
  }
    */
  
  return {course_status: course_status, modules_arr: modules_arr};

}

export const getModulesStatus = (repo) => {

  let status = repo.status;
  if(repo.status !== STATUS_COURSE_COMPLETED){
    const pending = repo.moduls.filter(module => module.status !== STATUS_COURSE_VIEWED);
    if(!pending.length){
      status = STATUS_COURSE_COMPLETED;
    }
  }
  return status;

}

export const haveModulesPendings = (modules) => {
  const pending = modules.filter(module => module.status !== STATUS_COURSE_VIEWED);
  if(pending.length){
    return true;
  }
  return false;
}

export const slug = str => {
  str = str.replace(/^\s+|\s+$/g, ''); // trim
  str = str.toLowerCase();
  str = str
    .replace(/[^a-z0-9 -]/g, '') // remove invalid chars
    .replace(/\s+/g, '-') // collapse whitespace and replace by -
    .replace(/-+/g, '-'); // collapse dashes
  return str;
};

const removeAccents = (string = '') => string.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
const replaceSpacesForDashes = (string = '') => string.replace(/ /g, '-');

export const downloadFileFromUrl = (url, fileName = 'descarga') => {
  saveAs(url, replaceSpacesForDashes(removeAccents(fileName)), { autoBom: true });
};

export const validateEmail = (email) => {
  const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
}

export const getTrainingCategoryID = (pathname, trainings, from) => {

    let pathSplitted = null;
    let querySection = null;

    if(from == 'category'){
      pathSplitted = pathname.split('/');
      querySection = pathSplitted[pathSplitted.length - 1];
    }
    if(from == 'training'){
      pathSplitted = pathname.split('/');
      querySection = pathSplitted[pathSplitted.length - 2];
    }

    let indexData = null;
    let trainingData = null;
    trainings.map((training, index) => {
      if(slug(training.level) === querySection){
        trainingData = training;
        indexData = index;
      }
    })

    return {index: indexData, training: trainingData};

}

export const getTrainingID = (pathname, trainings, from) => {

  const pathSplitted = pathname.split('/');
  const querySection = pathSplitted[pathSplitted.length - 1];

  let indexData = null;
  let trainingData = null;
  trainings.map((training, index) => {
    if(slug(training.name) === querySection){
      trainingData = training;
      indexData = index;
    }
  })

  return {index: indexData, training: trainingData};

}

export const fixRolName = (rol) => {

  let rolname = '';

  switch (rol) {
    case 'expert':
      rolname = "Experto";
      break;
    case 'chief':
      rolname = "Jefe de Turno";
      break;
    case 'manager':
      rolname = "Empresario / Gerente";
      break;
    case 'territory':
      rolname = "Territory Manager";
      break;
    case 'district':
      rolname = "District Manager";
      break;
    case 'captain':
      rolname = "Capitán";
      break;
    case 'admin':
      rolname = "Administrador";
      break;
    case 'shell':
      rolname = "Shell User";
      break;
    default:
      rolname = "";
      break;
  }

  return rolname;

}

export const phonePrefix = () => {

  return [{prefix: "11", description: "Capital Federal"},
          {prefix: "221", description: "Buenos Aires - La Plata"},
          {prefix: "223", description: "Buenos Aires - Mar del Plata"},
          {prefix: "291", description: "Buenos Aires - Bahía Blanca"},
          {prefix: "3833", description: "Catamarca"},
          {prefix: "351", description: "Córdoba"},
          {prefix: "3783", description: "Corrientes"},
          {prefix: "3722", description: "Chaco"},
          {prefix: "2965", description: "Chubut"},
          {prefix: "343", description: "Entre Ríos"},
          {prefix: "3717", description: "Formosa"},
          {prefix: "388", description: "Jujuy"},
          {prefix: "2954", description: "La Pampa"},
          {prefix: "3822", description: "La Rioja"},
          {prefix: "261", description: "Mendoza"},
          {prefix: "3752", description: "Misiones"},
          {prefix: "299", description: "Neuquén"},
          {prefix: "2920", description: "Río Negro"},
          {prefix: "387", description: "Salta"},
          {prefix: "264", description: "San Juan"},
          {prefix: "2652", description: "San Luis"},
          {prefix: "2966", description: "Santa Cruz"},
          {prefix: "342", description: "Santa Fe - Santa Fe"},
          {prefix: "341", description: "Santa Fe - Rosario"},
          {prefix: "385", description: "Santiago del Estero"},
          {prefix: "381", description: "Tucumán"},
          {prefix: "2901", description: "Tierra del Fuego - Ushuaia"},
        ];

}

export const truncate = (input, ending, limit) => {

  if(input.length > limit){
    if(ending === '...'){
      return `${input.substring(0, limit)}${ending}`;
    }
    if(ending === '...ver más'){
      return <div>{input.substring(0, limit)}<span className="ver_mas">...ver más</span></div>;
    }
  }else{
    return input;
  }

}

export const openInNewTab = (url) => {
  window.open(url, '_blank', 'noopener,noreferrer');
};

export const getAnswedData = (secondary_actions, _id) => {
  const response = secondary_actions.filter(answer => answer._id == _id);
  if(response.length){
    let resp = {...response[0]};
    resp["is_selected"] = true;
    return resp;
  }
  return null;

}

export const answerSuccess = (score, penalty_score, secondary_actions, answers) => {

  let isTrue = true;
  let originaScore = 0;

  secondary_actions.map((s_a, i) => {
    if(s_a.correct){
      if(!answers.includes(s_a._id)){
        isTrue = false;
      };
    }
  })

  return {action: isTrue ? "plus" : "minus",
          score: isTrue ? score : penalty_score,
          status: isTrue ? 1 : -1,
          origina_score: originaScore};

}

export const getTotalReactions = (post) => {
  const likes = post.likes_counter ? post.likes_counter : 0;
  let total_reactions = 0;
  post.reaction_counter.map((reaction, index) => {
    total_reactions += reaction.count;
  })
  return likes + total_reactions;
}

export const getReactionIcon = (reactions, reaction) => {
  const my_reaction = reactions.filter(r => r._id == reaction);
  if(my_reaction.length){
    switch (my_reaction[0].name) {
      case 'thinking':
          return <img src={'./images/icon_reaction_thinking.png'} />;
        break;
      case 'party':
          return <img src={'./images/icon_reaction_party.png'} />;
        break;
      case 'clap':
          return <img src={'./images/icon_reaction_clap.png'} />;
        break;
      case 'smile':
          return <img src={'./images/icon_reaction_smile.png'} />;
        break;
      case 'heart':
          return <BsFillHeartFill className={`fill_heart`} />;
        break;
      default:
        break;
    }
  }
  /*
  {reaction.name == "like" && }
  {reaction.name == "angry" && <img src={'./images/icon_reaction_angry.png'} />}
  {reaction.name == "party" && <img src={'./images/.png'} />}
  {reaction.name == "clap" && <img src={'./images/.png'} />}
  {reaction.name == "smile" && <img src={'./images/.png'} />}
  */
}

export const getReactionName = (reactions, reaction) => {

  const my_reaction = reactions.filter(r => r._id == reaction);
  if(my_reaction.length){
    return my_reaction[0].name;
  }
  return "";

}

export const isObject = (value)  =>{
  return (
    typeof value === 'object' &&
    value !== null &&
    !Array.isArray(value)
  );
}


export const checkBadWords = (comment)  => {

  const bardWords = ["Boluda","Puto","Puta","Trolo","Trola","Gay","Concha","Pene","Vagina","Pete","Pt","Mierda","Culo","Forro","Forra","Pedófilo","Ql","Culiao","Pito","Verga","Estúpido","Violador","Parió","Pelotudo","Pelotuda","Nazi","Hitler","Satán","Satan","Estúpido","Tarado","Idiota","Boludo","Boluda","Lesbiana","Huevon","Retardada","Retardado","Isis","Down","Pis","Meo","Leche","Sorete","Tetas","Huevos","Testículos","Escroto","Falo","Fellatio","Porno","Mariuhana","Faso","Cocaina","Paco","Fafafa","Cobani","Pija","Garcha","Poronga","Cagada","Cagar","Forrada","Boliguayo","Guasca","Wasca","Waska","Wask","Pezones","Chota","Choto","Chotada","Pinchila","Tilinga","Cajeta","Cajetudo","Cajetuda","Papuda","Conchuda","Conchudo","Mogólico","Mogolico","Gordinegro","Gordinegra","Pendejo","Pendeja","Cogida","Porro","Falopa","Falopero","Merquero","Maconia","Porrito","Fasito","Cachucha","Cachufleta","Clítoris","Orto","Putita","Putito","Culito","Lechita","Lechoso","Pedo","Pedito","Boludito","Boludita","Homosexual","Droga","Tragaleche","Tragasable","Conchita","Salamín","Jodete","Joda","Joder","Guacho","Guacha","Wacho","Wacha","Wachin","Guachin","Gila","Gilada","Giles","Papo","Totó","Papusa","Sudaca","Sudaka","Sudak","Merluza","Tomón","Drogadicto","Ojete","Ojetudo","Ortudo","Pajero","Pajera","Jeropa","Masturbación","Masturbar","Masturbatorio","Pajeando","Farlopa","Frula","Caquero","Pitito","Pito","Ortuda","Bolas","Empomar","Cagón","Cagon","Cagadera","Diarrea","Bulto","vulto","Bultear","Bagarto","Bagayero","Chapar","tranzar","Transar","Transa","Maricón","Marica","Ramera","Desnudo","Verguita","Vuergudo","Vergón","berga","Tuca","Tuquera","Pitos","Pitocorto","Tobul","Garompa","kk","Caca","Culon","Culón","Choton","Chotón","Culaso","Culazo","Putazo","Putaso","Putón","Putasa","Putaza","Pijazo","Porongo","Porongazo","Porongaso","Trolazo","Trolaso","Trolita","Putasos","Trolito","Tonto","Tonta","Imbécil","inbecil","imvecil","Imbecil","Pelotudito","Pelotudita","Pornográfico","Lechazo","Sidoso","Sidosa","Putísima","Putisima","Soretón","Soretito","Pijita","Longaniza","Poronguita","Pendejito","Pendejita","Estúpido","Estúpida","Estupido","Estupida","Chotita","Tontita","Tontito","Preservativo","Mierdita","Tuquita","Canceroso","Cancerosa","Wea","Wn","Weon","Weón","Cogidita","Desnudita","Desnuda","Desnudito","Ortitio","Cacona","Piyar","Gilún","Logi","Travesti","Forrito","Trabuco","Trava","Salame","Tetotas","Mamada","Mamas","Pechos","Tetazas","Tetona","Tetitas","Entangado","Entangada","Sanjuda","Sanjona","Pijota","Pijudo","Vergota","Vergotas","Wasqueada","Wasqueame","Acabame","Vergo","Verguita","Púbis","Bubis","Boobis","Boobies","Conchazo","Prolapso","Anal","Boludazo","Boludeces","Pelotudeces","Boludinas","Pendejadas","Entimbrado","Entimbrada","Erecto","Erección","Mierdas","Mierdota","Soretazo","Soretaso","Soretes","Estupidito","Estupidita","Estupideces","Estupidez","Pelotudez","Pelotudos","Forros","Forreados","Forreadas","Forrito","Gorreado","Yuta","Forreada","Mierdeado","Gonorrea","Leproso","Mierdón","Menstruación","Fellatio","Turk","Turca","Besonegro","Chupón","Chuponcito","Peteada","Lecheada","Chupapija","Vergamota","Prepucio","Lamerla","Tetuda","Cachuchita","Cachu","Papota","Gey","Homosesual","Rosquete","Cabecita","Tararira","Tirapedos","Prostitución","Violín","Penetración","Guarra","Pechitos","Eyaculación","Eyaculo","Gemir","Argolluda","Carajo","Carajear","Rastrero","Tumbero","Villero","Zorra","Zorrita","Ocote","Aborto","Charuto","Mandanga","Burundanga","Cáncer","Coito","Erotismo","Erótico","Facho","Setiembre","Feminazi","Menopáusica","Orgasmo","Orgásmico","Pezones","Tuberculosis","Tuberculoso","Lepra","Culón","Culona","Coño","Coñito","Coñazo","Chilote","Boludes","Boludez","Voludo","Voluda","Voludes","Voludez","Voludito","Voludita","Putah","Putitah","Putitoh","Putoh","Fachos","Orgasmear","Miar","Miando","Ratis","YPF","AXION","PETROBRAS","ESSO","ASPRO","OIL","REFINOR","PDVsur","SERVICLUB","INFINIA","ELAION","MOBIL","ESSENCIAL","mear","pillar","piyar","garco","garcar","fuck","fucking","upite","cola","escabio","eskvio","eskbio","escavio","cotorra","cotorrita","p u t o","put@","Mogólico","maricon","maricona","Vuergudo","Culon","Culón","Choton","Chotón","Culaso","Culazo","Putazo","Putaso","Putón","Putasa","Putaza","Pijazo","Porongo","Porongazo","Porongaso","Trolazo","Trolaso","Trolita","Putasos","Trolito","Tonto","Tonta","Imbécil","Imbecil","Pelotudito","Pelotudita","Pornográfico","Lechazo","Sidoso","Sidosa","Putísima","Putisima","Soretón","Soretito","Pijita","Longaniza","Poronguita","Pendejito","Pendejita","Estúpida","Estupido","Estupida","Chotita","Tontita","Tontito","Preservativo","Mierdita","Tuquita","Canceroso","Cancerosa","Wea","Wn","Weon","Weón","Cogidita","Desnudita","Desnuda","Desnudito","Ortitio","Cacona","Piyar","Gilún","Logi","Travesti","Forrito","Trabuco","Trava","Salame","Tetotas","Mamada","Aureola","Aureolas","Mamas","Pechos","Tetazas","Tetona","Tetitas","Entangado","Entangada","Sanjuda","Sanjona","Pijota","Pijudo","Vergota","Vergotas","Wasqueada","Wasqueame","Acabame","Vergo","Púbis","Bubis","Boobis","Boobies","Conchazo","Prolapso","Anal","Boludazo","Boludeces","Pelotudeces","Boludinas","Pendejadas","Entimbrado","Entimbrada","Erecto","Erección","Mierdas","Mierdota","Soretazo","Soretaso","Soretes","Estupidito","Estupidita","Estupideces","Estupidez","Pelotudez","Pelotudos","Forros","Forreados","Forreadas","Forrito","Gorreado","Yuta","Forreada","Mierdeado","Gonorrea","Leproso","Mierdón","Menstruación","Turk","Turca","Besonegro","Chupón","Chuponcito","Peteada","Lecheada","Chupapija","Vergamota","Prepucio","Lamerla","Tetuda","Cachuchita","Cachu","Papota","Gey","Homosesual","Rosquete","Cabecita","Tararira","Tirapedos","Prostitución","Violín","Penetración","Guarra","Pechitos","Eyaculación","Eyaculo","Gemir","Argolluda","Carajo","Carajear","Rastrero","Tumbero","Villero","Zorra","Zorrita","Ocote","Aborto","Charuto","Mandanga","Burundanga","Cáncer","Coito","Coito","Erotismo","Erótico","Facho","Setiembre","Feminazi","Menopáusica","Orgasmo","Orgásmico","Tuberculosis","Tuberculoso","Lepra","Culón","Culona","Coño","Coñito","Coñazo","Chilote","Boludes","Boludez","Voludo","Voluda","Voludes","Voludez","Voludito","Voludita","Putah","Putitah","Putitoh","Putoh","Fachos","Orgasmear","Miar","Miando","Ratis","Putas","Putos","Putaso","Putazo","Putasa","Putaza","Coger","Cojer","Pel0tudos","Pelotud0s","Pel0tud0s","Pelotudo.","Peroltudos.","Mierd@","Mierd@as","Pelotud@","Pelotud@s","Putta","Putto","Puto.","Puto-","Puta.","puta.","Idiotas","Idiotta","Idiottas","Idiota","Idiotas","Idiota.","Idiotas.","Chupa","Pijaaa","0rto","0rt0","ort0","remilputa","remil","put4","put0","pijas","p1jas","bobo","boba","chup@","pijaz0","ped0filo","tr0la","tr0lo","trol0","tr0l0","chele","pijaz","YPF","ypf","bitch","bitches","huevón","putos","argolludas","huevones","trolaso","trolos","bobos","bobas","putoss","putosss","putossss","putos!","pelotudoss","pelotudos!","fachos","bolud","put","conch","tarad","pelotud","marika","marik","maric","hijodepu","orgasm","contaminación","contaminacion","culeado","culeada","Caco","menarca","alcornoque","basoso","babosa","cretino","cretina","kretino","kretina","yegua","descerebrado","descerebrada","energúmeno","lameculo","lameculos","malparido","malparida","pedorro","pedorra","gorda","gordo","piojoso","piojosa","berga","bosta","chupala","2pala","imbeciles","imbécil","cornudo","cornuda","pajita","pajota","petear","inutil","inútil","fracasado","fracasada","fracaso","esperma","espermatozoide","óvulo","putis","villera","villerito","villerita","buacho","buacha","vuacho","vuacha","guachada","wachada","buachada","falopera","falopita","careta","kreta","orina","quilombo","kilombo","nabo","navo","vulva","clítoris","copular","omosexual","omosesual","forrear","forr","recalcada","croto","crota","meada","meado","masturbarte","masturbacion","masturbado","masturbate","fifar","prostituta","prostíbulo","porronga","poronguin","tortillera","kulo","cojiendo","cogiendose","P.uto","Pu.to","Put.o","P.u.to","Pu.t.o","P.ut.o","P.uta","Pu.ta","Put.a","P.u.ta","Pu.t.a","P.ut.a","Trucha","Trucho","trucha","trucho","chanta","chantada","Chanta","Chantada","Mentiroso","Mentirosa","Mentiras","Mentiras","Sexy","Sexual","Sexi","Sexopata","Trans","trans","Binario","binario","Transexual","Cisgénero","Transgénero","conchu2","pelotu2","bolu2","cornu2","conchu@","pelotu@","bolu@","cornu@"];

  let keyReplacement;
  let lowerString;
  let string = comment.replace(/<(?:.|\n)*?>/gm, '');
  let replacements = 0;

  lowerString = string.toLowerCase();
  // loop through each key in the dictionary and search for matches
  // (seems like it'd be faster to indexOf on all keys and run replace on matches, rather than replace all)
  bardWords.forEach(item => {
    const lowerItem = item.toLowerCase(); // lowercase the bad word
    let index = lowerString.indexOf(lowerItem); // find it in the string
    while (index !== -1) {
      // Esta es la validación que había antes, obviamente como es un textarea no se puede introducir HTML. Queda como fix para el futuro.
      keyReplacement = `<span class="bad-word">${string.substr(index, item.length)}</span>`; // replace the bad word with a span to style it
      string = string.substr(0, index) + keyReplacement + string.substr(index + item.length); // add the replaced bad word to the string
      lowerString = string.toLowerCase(); // get the new string replaced
      index = lowerString.indexOf(lowerItem, index + keyReplacement.length); // find other occurrences
      // eslint-disable-next-line no-plusplus
      replacements++; // keep the count
    }
  });

  comment = string; // assign the filtered string
  return { replacements, comment };
}

export const incentivoTiendas = (bocas) => {

  if(bocas){
    const stations = []
    const result = bocas.filter(boca => stations.includes(boca.code));
    return result.length ? true : false;
  }else{
    return false;
  }

}

export const bocas_seguridad_2024 = [];
export const dnis_seguridad_2024 = [];
export const inventivo_tiendas_2 = [28337211];
export const show_baristas = [];

export const encryptAES = (data) => {
  const ciphertext = CryptoJS.AES.encrypt(data, process.env.REACT_APP_ENKEY).toString();
  return ciphertext;
};

export const decryptAES = (data) => {
  const decrypted = CryptoJS.AES.decrypt(data, process.env.REACT_APP_ENKEY);
  return decrypted;
};

export const bocas_cocacola = ["2","3","5","10","14","19","21","28","29","31","36","46","48","53","54","55","60","62","65","66","72","79","82","87","89","91","95","96","109","113","145","146","168","169","174","177","187","192","193","240","263","271","275","281","284","289","312","331","337","348","354","381","390","392","395","409","430","445","448","454","459","460","461","486","497","502","504","508","539","548","549","584","589","599","610","617",
"622","624","626","630","631","640","649","656","688","691","698","700","718","721","734","737","738","742","752","760","781","804","805","807","811","815","848","851","878","890","896","901","903","954","981","987","1009","1020","1047","1049","1051","1056","1062","1066","1068","1085","1095","1107","1132","1136","1137","1139","1142","1153","1157","1158","1164","1178","1182","1212","1220","1224","1225","1229","1230","1231","1232","1233","1242","1247","1249","1250","1260","1269","1274","1280","1291","1308","1324","1327","1344","1347","1363","1364","1368","1378","1389","1396","1401","1403","1405","1409","1411","1415","1416","1417","1425","1426","1428","1431","1438",
"1439","1443","1444","1445","1446","1449","1450","1454","1461","1464","1468","1469","1472","1478","1482","1486","1487","1488","1490","1494","1498","1501","1503","1505","1506","1507","1524","1528","1539","1541","1542","1550","1553","1566","1569","1572","1576","1577","1584","1590","1591","1596","1601","1604","1617","1619","1620","1629","1630","1631","1633","1635","1640","1641","1646","1648","1655","1663","1667","1668","1672","1681","1682","1683","1695","1700","1702","1706","1708","1710","1711","1714","1715","1716","1717","1718","1722","1729","1733","1735","1736","1741","1746","1751","1758","1760","1771","1775","1777","1781","1782","1787","1789","1790","1793","1795","1796","1797","1801","1806",
"1814","1818","1825","1828","1829","1830","1831","1832","1837","1838","1844","1845","1849","1850","1852","1854","1856","1859","1861","1865","1867","1868","1870","1872","1877","1878","1880","1882","1888","1890","1891","1894","1899","1900","1902","1907","1908","1910","1919","1923","1924","1931","1932","1933","1941","1945","1956","1957","1958","1965","1976","1981","1983","1985","1989","1990","1994","1995","1997","2000","2002","2005","2008","2012","2013","2014","2017","2031","2033","2036","2040","2041","2045","2051","2058","2075","2078","2094","2095","2101","2102","2107","2108","2115","2118","2122","2124","2130","2134","2141","2143","2153","2154","2156","2157","2158","2159","2161","2163","2164","2165","2166","2168","2169","2170","2172","2175","2176","2179","2180","2185","2186","2187","2188","2192","2193","2203","2205","2206","2208","2212","2213","2232","2234","9999","10000","20000"];
